import BaseService from './BaseService'
import config from './../config/index'
import axios from 'axios'

class MediaService extends BaseService {
  constructor(baseUrl) {
    super(baseUrl)
  }

  uploadToBucket = (file, signedUrl) => {
    return axios.put(signedUrl, file, {
      headers: {
        'Content-Type': file.type,
        'Access-Control-Allow-Origin': '*',
      },
    })
  }
  verify = (aknId, locationId) => {
    const body = {
      altType: 'location',
      altId: locationId,
      id: aknId,
    }
    return this.requests.post('/files/verify', body)
  }
}

export const mediaService = new MediaService(config.mediaServiceUrl)

export default {}